import VueImgix from '@imgix/vue';
import Vue from 'vue';

Vue.component('imgix-client-init', {
    props: {
        imgixUrl: {
            type: String,
        },
    },
    mounted() {
        Vue.use(VueImgix, {
            domain: this.imgixUrl,
            defaultIxParams: {
                auto: 'format',
            },
        });
    },
});
